import { Component, Input, Output, EventEmitter, Inject, OnInit } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';

import { NgEventBus } from 'ng-event-bus';

import { ContextService } from '@app/auth/context.service';
import { MqttService } from 'ngx-mqtt/src/mqtt.service';
import { IMqttMessage } from 'ngx-mqtt';
import { interval, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Point } from 'chart.js';
import { observable } from 'rxjs/internal-compatibility';

@Component({
  selector: 'session-graph-form',
  template: `<app-line-chart-reactive [mqttEventObserve]="mqttEventObserve" [deviceSerialNumber]=deviceSerialNumber></app-line-chart-reactive>`,
  // styleUrls: ['./session-graph-form.component.css']
  styles: [`
  :host {
      display: inline-block;
      width: 100%;
      height: 400px;
      position: relative;
  }
`]
})
export class SessionGraphFormComponent implements OnInit {
  // @Input() machine: any;
  @Input() device: any;
  // @Input() weldSession: any;
  public deviceSerialNumber: string;
  public subscriptionEvent: any;
  @Input() data: any;
  public chartTitle: String = "Gráfica Vibración RMS";
  mqttEventObserve: Observable<IMqttMessage>
  constructor(
    private eventBus: NgEventBus,
    private dialog: DialogRef,
    private mqttService: MqttService,
  ) {
    this.mqttEventObserve = this.mqttService.observe(`/mqtt/events/message/#`);
  }

  ngOnInit(): void {
    this.deviceSerialNumber = this.device
    
  }

  private closeForm(event): void {
    this.dialog.close();
  }

  public onClose(event): void {
    event.preventDefault();

    this.closeForm(event);
  }

  ngOnDestroy(): void {
    // this.mqttEventObserve.unsubscribe();
  }
}
